import { Container, Grid } from '@material-ui/core';
import React from 'react';
import { Avatar } from '../../components/common/Cards';
import { Paper } from '../../components/common/Containers';
import { SpacingContainer } from '../../components/common/Containers/Base';
import Typography from '../../components/common/Typography';
import SpacingContainerBase from '../../components/layouts/SpacingContainerBase';
import useUserFullName from '../../hooks/useUserFullName';
import { useTrans } from '../../services/i18n';
import { formatPrettyUnixDate } from '../../utils/dateUtils';
import connect from './connect';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import SecurityIcon from '@material-ui/icons/Security';
import Card from './components/card';
import PersonalInformation from './PersonalInformation';
import TwoFactorAuthentication from './TwoFactorAuthentication';

const useStyles = makeStyles(() => ({
  gridsContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '2.5rem',
  },
  singleCard: {
    display: 'flex',
    padding: '2.5rem 0rem',
  },
  singleCardContent: {
    gap: '0.4375rem',
  },
}));

function Profile({ authUser = {}, updateMFA, updatePhone, updatePersonalInformation }) {
  const { trans } = useTrans();
  const user = authUser || {};
  const fullName = useUserFullName(user);
  const styles = useStyles();

  const loginDate = React.useMemo(() => {
    const date = user.lastLogin || user.authTime;

    if (!date) {
      return '';
    }

    return formatPrettyUnixDate(date, 'MM/DD/YYYY, h:mm A');
  }, [user.authTime, user.lastLogin]);

  return (
    <SpacingContainerBase>
      <Container className={styles.gridsContainer}>
        <Typography weight="600" variant="h2" fontFamily="lexend">
          {trans('my-profile')}
        </Typography>

        <Paper component={SpacingContainer} px={2} py={3} className={styles.singleCard}>
          <Grid
            container
            direction="column"
            alignItems="center"
            component={SpacingContainer}
            className={styles.singleCardContent}
          >
            <Avatar value={fullName} variant="h1Medium" />

            <Typography weight="700" variant="h1Medium">
              {fullName}
            </Typography>

            <Typography weight="500" variant="body1" color="label">
              {user.email || ''}
            </Typography>

            {loginDate && (
              <Grid container direction="column" alignItems="center">
                <Typography color="hint" variant="caption">
                  {`${trans('lastLogin')}:`} {loginDate}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Paper>

        <Grid container spacing={4} alignItems="flex-start">
          <Grid item xs={12} md={7}>
            <Card title={trans('personal-information')} icon={<PersonOutlineIcon />}>
              <PersonalInformation user={user} onUpdate={updatePersonalInformation} />
            </Card>
          </Grid>

          <Grid item xs={12} md={5}>
            <Card title={trans('two-factor-authentication')} icon={<SecurityIcon />}>
              <TwoFactorAuthentication auth={user} onUpdate={updateMFA} updatePhone={updatePhone} />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </SpacingContainerBase>
  );
}

export default connect(Profile);